import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { ROOT_API } from "../../api/config";
import { updateUserInformation } from "../../stores/users/userSlice";
import Layout from "../layout/index";

// One-click magic-login landing (/auto-prijava?token=...). Exchanges the signed 24h token from the
// reminder email for a normal session, then drops the user on the add-address page.
const AutoLogin = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      setFailed(true);
      return;
    }
    let alive = true;
    (async () => {
      try {
        const res = await axios.post(`${ROOT_API}apis/auth/magic-login`, { token });
        const data = res?.data?.data;
        if (!data || !data.access_token) throw new Error("no token");
        localStorage.setItem("access_token", data.access_token);
        if (data.user_data) dispatch(updateUserInformation(data.user_data));
        if (alive) navigate("/register-service", { replace: true });
      } catch (e) {
        if (alive) setFailed(true);
      }
    })();
    return () => {
      alive = false;
    };
  }, [navigate, dispatch]);

  return (
    <Layout>
      <div className="general-form">
        <div className="container">
          <div style={{ textAlign: "center", padding: "60px 20px" }}>
            {failed ? (
              <>
                <p style={{ marginBottom: 18 }}>
                  {intl.formatMessage({ id: "magic_login_failed" })}
                </p>
                <Link to="/login" className="btn-cta">
                  {intl.formatMessage({ id: "switch_to_login" })}
                </Link>
              </>
            ) : (
              <p>{intl.formatMessage({ id: "magic_login_loading" })}</p>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AutoLogin;
